import { lazy } from "react";
import MainView from "../views/MainView";

const ShitSwap = lazy(() => import("../views/ShitSwap"));
const WhitePaper = lazy(() => import("../views/WhitePaper"));
const Prices = lazy(() => import("../views/Prices"));

const routes = [
	{ path: "/shitswap", component: ShitSwap },
	{ path: "/whitepaper", component: WhitePaper },
	{ path: "/prices", component: Prices },
	{ path: "/", component: MainView },
];

export default routes;
